module.exports = "/packs/images/homepage/facilities/swim-school~349a86b4756e8039813f19c3d592792a.jpg";